import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

var config = {
  apiKey: "AIzaSyACloInME43-2KP3LZALoMGRfz0Y1aOm1E",
  authDomain: "splice-a918d.firebaseapp.com",
  projectId: "splice-a918d",
  databaseURL: "https://splice-a918d.firebaseio.com"
};
firebase.initializeApp(config);
export default firebase;


// WEBPACK FOOTER //
// ./src/Config/Firebase.js